function Trashbin({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || '32'} height=${dimensions || '32'} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_934_5185)">
  <path d="M8.0013 25.3333C8.0013 26.8 9.2013 28 10.668 28H21.3346C22.8013 28 24.0013 26.8 24.0013 25.3333V9.33333H8.0013V25.3333ZM25.3346 5.33333H20.668L19.3346 4H12.668L11.3346 5.33333H6.66797V8H25.3346V5.33333Z" fill="white"/>
  </g>
  <defs>
  <clipPath id="clip0_934_5185">
  <rect width="32" height="32" fill="white"/>
  </clipPath>
  </defs>
  </svg>

  `;

  return baseXml;
}

export default Trashbin;
